module.exports = __webpack_public_path__ + "static/media/icon_strategy.dc188ee1.svg";